import { LOADING, SET_CURRENT_USER_DISCOUNT, SET_CURRENT_WEBSITE_PLAN_LIST } from "../../Actions/Types";
import { getCurrentPackageApi, getPlanListApi, getScanningMonitoringDomainActiveStatusApi, getScanningMonitoringDomainRegisterLoginApi, getScanningMonitoringPackageApi } from "../../Api/PlanListApi";
import decodeBase64 from "../../Helpers/decodeBase64";
import encodeBase64 from "../../Helpers/encodeBase64";


// service to get plan list and store it
const getPlanListService = (
    token: string, // access token
    planType: number, // plan type
    dispatch: Function // function to store redux data
) => {

    console.log("getPlanListService is called");

    // Set Loading
    if (planType !== 2) {
        dispatch({
            type: LOADING,
            payload: true,
        });
    }

    // get plan list API
    getPlanListApi(token, planType).then((planRes) => {

        // check if plan data is available
        if (planRes.Data) {

            // check plan tye
            if (planType === 2) {

                // dispatch to store plan data
                dispatch({
                    type: SET_CURRENT_WEBSITE_PLAN_LIST,
                    payload: planRes.Data,
                });

            }

            if (planType !== 2) {
                // Set Loading
                dispatch({
                    type: LOADING,
                    payload: false,
                });
            }

        }

        // check if discount information is available
        if (planRes.discount_details) {
            dispatch({
                type: SET_CURRENT_USER_DISCOUNT,
                payload: planRes.discount_details,
            });
        }

    });
}


// function to get current plan details
const getCurrentPackageDetails = (
    token: string, // access token
    packageID: number, // active plan Id
    websiteID: number, // website id
    dispatch: Function, // function to store data
    setCurrentAddOnDetails: Function // set state
) => {

    // Loading
    dispatch({
        type: LOADING,
        payload: true,
    });

    // api to get current package details
    getCurrentPackageApi(token, packageID, websiteID).then((currentPackageRes) => {
        // check if current package data is available
        if (currentPackageRes.Data) {

            //set data to state
            setCurrentAddOnDetails(currentPackageRes.Data);

            // Loading
            dispatch({
                type: LOADING,
                payload: false,
            });
        }
    })
}

const getScanningMonitoringPackageDetails = (
    token: string, // access token
    dispatch: Function, // function to store data
    setPurchasedAddOnDetails: Function, // set state
    setCurrentAddOnDetails: Function // set state
) => {

    // Loading
    dispatch({
        type: LOADING,
        payload: true,
    });

    // api to get Sacnning Monitoring package details
    getScanningMonitoringPackageApi(token).then((currentPackageRes) => {
        // check if current package data is available
        if (currentPackageRes.Data) {

            //set data to state
            setCurrentAddOnDetails(currentPackageRes.Data);

            setPurchasedAddOnDetails(currentPackageRes.Data);

            // Loading
            dispatch({
                type: LOADING,
                payload: false,
            });
        }
    })
}

const getScanningMonitoringDomainRegisterLogin = (
    token: string, // access token
    dispatch: Function, // function to store data
    companyName: string | null, // set state
    email:string | null,
    name:string | null,
    domain:string | null,
    package_id:string,
    interval:string,
    setDomainRegisterLoginDetails: Function, // set state
    navigate: Function // set state
) => {

    // Loading
    dispatch({
        type: LOADING,
        payload: true,
    });

    // api to get Sacnning Monitoring package details
    getScanningMonitoringDomainRegisterLoginApi(token, companyName ? companyName : '', email ? email : '',name ? name : '',domain ? domain : '', package_id, interval).then((currentPackageRes) => {
        // check if current package data is available
        if (currentPackageRes) {
            const encodedString = decodeBase64(currentPackageRes.payment_slug).split("|")
            console.log('encodedString: ', encodedString);
            encodedString.pop()
            encodedString.push("70")
            navigate(`/front/package/${encodeBase64(encodedString.join('|'))}`)
            //set data to state
            setDomainRegisterLoginDetails(currentPackageRes.Data);

            // Loading
            dispatch({
                type: LOADING,
                payload: false,
            });
        }
    })
}

const getScanningMonitoringActivePlanStatus = (
    token: string, // access token
    domain:string, // domain name
    setIsScanningMonitoring:Function, //set state
    setscanningMonitoringUrl:Function //set state
) => {

    getScanningMonitoringDomainActiveStatusApi(token, domain).then((currentPackageRes) => {
        // check if current package data is available
        if (currentPackageRes) {
            setIsScanningMonitoring(currentPackageRes.is_purchased)
            setscanningMonitoringUrl(currentPackageRes.auto_login_link)
            //set data to state
        }
    })
}

export { getPlanListService, getCurrentPackageDetails, getScanningMonitoringPackageDetails, getScanningMonitoringDomainRegisterLogin, getScanningMonitoringActivePlanStatus };